import React, { forwardRef } from 'react';
import { Logo, LogoProps } from 'src/components/elements/logo/Logo';
import { useNavigation } from '@rexlabs/navigation';

export const MenuLogo = forwardRef<SVGSVGElement, LogoProps>((props) => {
  const { isExpanded } = useNavigation();
  return <Logo {...props} type={isExpanded ? 'primary_white' : 'mark'} />;
});
